// BrowserTypes.ts
export enum BrowserType {
  Chrome = "Chrome",
  Safari = "Safari",
  Unknown = "Unknown",
}

export interface BrowserInfo {
  type: BrowserType;
  version: string;
}
